import { Sens } from '@mairistem/comptabilite';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import { Table } from 'rsuite-table';
import type Projet from '../../interfaces/common/projet';
import { getCreditsPaiementsTotaux } from '../../services/projet';
import { ROW_HEIGHT } from './CreditPaiementTreeView';
import './CreditPaiementTreeView.css';
import './CreditPaiementTreeViewFooter.css';

interface CreditPaiementTreeViewFooterProps {
	decision?: number;
	exercice?: string;
	identifiantEntiteCompta?: string;
}
const CreditPaiementTreeViewFooter = ({
	decision,
	exercice,
	identifiantEntiteCompta,
}: CreditPaiementTreeViewFooterProps) => {
	const [data, setData] = React.useState<Projet[]>([]);

	React.useEffect(() => {
		async function fetchData() {
			const result = await getCreditsPaiementsTotaux(
				new URLSearchParams({
					...(decision ? { decision: decision.toString() } : {}),
					exercice,
					identifiantEntiteCompta,
					sens: Sens.DEPENSE,
				}),
			);
			setData([result]);
		}

		fetchData();
	}, [exercice, decision, identifiantEntiteCompta]);

	const renderCellValue = (value: any) => {
		if (value === undefined || value === null || value === 0) {
			return '-';
		}

		const v = parseFloat(value);
		return (
			<span className={`montant ${v < 0 ? 'negative' : ''}`}>
				{formatMontant(v)}
			</span>
		);
	};

	return (
		<Table<Projet, string>
			data={data}
			showHeader={false}
			height={ROW_HEIGHT}
			rowHeight={ROW_HEIGHT}
			locale={{
				emptyMessage: 'Aucun totaux',
				loading: 'Chargement des crédits de paiement...',
			}}
		>
			{({ Cell, Column, HeaderCell }) => (
				<>
					<Column flexGrow={6} verticalAlign="middle" align="left">
						<HeaderCell> </HeaderCell>
						<Cell
							dataKey="realiseAnterieur"
							align="left"
							className="total-cell"
						>
							TOTAL
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="realiseAnterieur">
							{(rowData) => renderCellValue(rowData.realiseAnterieur)}
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="creditPaiement">
							{(rowData) => renderCellValue(rowData.creditPaiement)}
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="mandat">
							{(rowData) => renderCellValue(rowData.mandat)}
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="engagement">
							{(rowData) => renderCellValue(rowData.engagement)}
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="disponible">
							{(rowData) => renderCellValue(rowData.disponible)}
						</Cell>
					</Column>

					<Column flexGrow={4} verticalAlign="middle" align="right">
						<HeaderCell> </HeaderCell>
						<Cell dataKey="creditSuperieur">
							{(rowData) => renderCellValue(rowData.creditSuperieur)}
						</Cell>
					</Column>
					<Column width={200}>
						<HeaderCell> </HeaderCell>
						<Cell dataKey="gap" />
					</Column>
				</>
			)}
		</Table>
	);
};

export default CreditPaiementTreeViewFooter;
